import { SxProps } from "@mui/system";
import { MiscSavio, StyleguideSavioFonts } from "../../../../configuration/themeSettings";

import { Accordion, styled, useTheme } from "@mui/material";

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        tableRow: {
            cursor: "pointer",

            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
            },

            "& td>svg": {
                color: theme.palette.primary.main,
            },

            "&:last-child td, &:last-child th": {
                border: 0,
            },
        } as SxProps,

        iconSize: {
            fontSize: 26,
            "&:hover": {
                color: MiscSavio.hoverColor,
            }
        } as SxProps,



        iconCell: {
            paddingBottom: 5 + "px !important",
            "a": {
                color: theme.palette.primary.main,
            },
            "&.icons": {
                width: 80,
                textAlign: 'left',

                "svg:hover": {
                    color: MiscSavio.hoverColor,
                }
            }


        } as SxProps,

        tooltip: {
            fontWeight: StyleguideSavioFonts.normal,

            "b": {
                fontWeight: StyleguideSavioFonts.bold,
            }

        } as SxProps,
    };
    return classes;
};

export const TitleTextAccordion = styled("span", { label: "InstalledBasePage-titleTextAccordion" })(({ theme }) => ({
    color: theme.palette.primary.main,
    fontSize: 20,
    fontWeight: StyleguideSavioFonts.medium,
    marginLeft: 75,
})
);


export const SectionIcon = styled("div", { label: "InstalledBasePage-sectionIcon" })(({ theme }) => ({
    position: 'absolute',
    top: -25,
    left: 5,
    border: "1px solid " + theme.palette.primary.main,
    borderRadius: 100,
    width: 65,
    height: 65,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
    "svg": {
        fontSize: 35,
        color: theme.palette.primary.main,
    }
})
);

export const AccordionStyled = styled(Accordion, { label: "InstalledBasePage-accordionStyled" })(({ theme }) => ({
    boxShadow: "none",

    ".MuiAccordion-heading": {
        boxShadow: "var(--Paper-shadow)",
    },
    "&:before": {
        display: 'none',
    },

    ".MuiCollapse-root": {
        minHeight: 5 + "px !important",
    },
    ".MuiTableRow-root:last-child": {
        ".MuiTableCell-root": {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
        }
    }
})
);